import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdIconComponent } from '@inditex/mduikit';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { DistanceSaleContractComponent } from './components/distance-sale-contract/distance-sale-contract.component';
import { InputTermsConditionsComponent } from './components/input-terms-conditions/input-terms-conditions.component';
import { InputTermsConditionsService } from './components/input-terms-conditions/input-terms-conditions.service';
import { InputTermsConditionsTermComponent } from './components/terms/terms.component';
import { TextTermsConditionsComponent } from './components/text-terms-conditions/text-terms-conditions.component';
import { AuthenticationConditionsModalComponent } from './modals/authentication-conditions/authentication-conditions.component';
import { GiftCardConditionsModalComponent } from './modals/gift-card-conditions/gift-card-conditions.component';
import { AcceptanceService } from './services/acceptance.service';
import { TermsConditionsDocumentsService } from './services/terms-conditions-documents.service';
import { TermsConditionsEffects } from './store/terms-conditions.effects';
import { termsConditionsReducer } from './store/terms-conditions.reducer';

import { UiMspotModule } from '@features/mspot/mspot.module';
import { ProcessInterpolationOnStringPipe } from '@shared/pipes/process-interpolation-on-string.pipe';
import { RgpdService } from '@shared/services/rgpd.service';
import { StaticResourceService } from '@shared/services/static-resources/static-resource.service';
import { DialogModule } from '@ui/dialog/dialog.module';

@NgModule({
    declarations: [
        AuthenticationConditionsModalComponent,
        DistanceSaleContractComponent,
        GiftCardConditionsModalComponent,
        InputTermsConditionsComponent,
        InputTermsConditionsTermComponent,
    ],
    imports: [
        CommonModule,
        DialogModule,
        TranslateModule.forChild(),
        FormsModule,
        UiMspotModule.forRoot(),
        MdIconComponent,
        ReactiveFormsModule,
        TextTermsConditionsComponent,
    ],
    exports: [
        AuthenticationConditionsModalComponent,
        GiftCardConditionsModalComponent,
        InputTermsConditionsComponent,
        TextTermsConditionsComponent,
    ],
    providers: [
        provideState({ name: 'terms-conditions', reducer: termsConditionsReducer }),
        provideEffects(TermsConditionsEffects),
        AcceptanceService,
        InputTermsConditionsService,
        ProcessInterpolationOnStringPipe,
        RgpdService,
        StaticResourceService,
        TermsConditionsDocumentsService,
    ],
})
export class TermsConditionsModule {}
